import React from 'react';
import { css } from '@emotion/react';

import Form from '$/components/ui/Form';
import Settings from '$/components/ui/Settings';
import Input from '$/components/ui/Input/Basics/Input';
import PhoneNumber from '$/components/ui/Input/PhoneNumber';
import UrlInput from '$/components/ui/Input/Basics/UrlInput';
import Textarea from '$/components/ui/Input/Basics/Textarea';

import { useMe } from '$/hooks/useMe';

export const PresenterInformationFields: React.FC = () => {
  const me = useMe();
  return (
    <div className='w-full'>
      <Settings.Title className='block w-11/12 mb-4'>Presenter profile</Settings.Title>
      <Settings.Description className='block mb-8'>
        If you are added to a webinar as a Presenter, the information below may be displayed to
        potential registrants on the webinar's landing page and to attendees in the webinar room.
      </Settings.Description>

      <div className='flex flex-col md:flex-row'>
        <div className='flex-1 md:mr-5'>
          <Form.FieldLabel title='First name' />
          <Form.Field
            name='details.presenterFirstName'
            component={<Input autoComplete='given-name' placeholder='First name' />}
          />
        </div>
        <div className='flex-1'>
          <Form.FieldLabel title='Last name' />
          <Form.Field
            name='details.presenterLastName'
            component={<Input autoComplete='family-name' placeholder='Last name' />}
          />
        </div>
      </div>

      <div className='flex flex-col md:flex-row'>
        <div className='flex-1 md:mr-5'>
          <Form.FieldLabel title='Company' />
          <Form.Field name='company' component={<Input placeholder='Company name shown' />} />
        </div>
        <div className='flex-1'>
          <Form.FieldLabel title='Title' />
          <Form.Field
            name='title'
            component={<Input placeholder='Title shown' autoComplete='organization-title' />}
          />
        </div>
      </div>

      <div className='flex flex-col md:flex-row'>
        <div className='flex-1 md:mr-5'>
          <Form.FieldLabel title='Email' />
          <Form.Field
            name='displayEmail'
            component={
              <Input autoComplete='email' className='max-w-none w-full' placeholder='Email shown' />
            }
          />
        </div>
        <div className='flex-1'>
          <Form.FieldLabel title='Phone' />
          <Form.Field
            name='phone'
            className='mt-1'
            component={<PhoneNumber country={me.lastCountry} placeholder='Phone shown' />}
          />
        </div>
      </div>

      <div className='w-full'>
        <Form.FieldLabel title='Bio' />
        <Form.Field name='bio' component={<Textarea rows={5} />} />
      </div>

      <Settings.Separator
        css={css`
          width: 100%;
          margin-top: 1rem;
          margin-bottom: 0;
        `}
      />

      <div className='flex flex-col md:flex-row'>
        <div className='flex-1 md:mr-5'>
          <Form.FieldLabel title='Twitter link' />
          <Form.Field name='socialLinks.twitter' component={<UrlInput />} />
        </div>
        <div className='flex-1'>
          <Form.FieldLabel title='Facebook link' />
          <Form.Field name='socialLinks.facebook' component={<UrlInput />} />
        </div>
      </div>

      <div className='flex flex-col md:flex-row'>
        <div className='flex-1 md:mr-5'>
          <Form.FieldLabel title='LinkedIn link' />
          <Form.Field name='socialLinks.linkedin' component={<UrlInput />} className='md:mb-0' />
        </div>
        <div className='flex-1'>
          <Form.FieldLabel title='Instagram link' />
          <Form.Field name='socialLinks.instagram' component={<UrlInput />} className='md:mb-0' />
        </div>
      </div>
    </div>
  );
};

export const PresenterInformation: React.FC = () => {
  return (
    <Settings.Section id='presenter-profile'>
      <Settings.Subsection>
        <PresenterInformationFields />
      </Settings.Subsection>
    </Settings.Section>
  );
};
